import React from 'react';
import { ModelInfo } from './types';

interface ModelPickerProps {
  models: ModelInfo[];
  value: string;
  disabled?: boolean;
  onChange: (modelId: string) => void;
}

// Dropdown of user-selectable models with a plain-language hint for the selection.
const ModelPicker: React.FC<ModelPickerProps> = ({ models, value, disabled, onChange }) => {
  const selected = models.find(m => m.id === value);
  return (
    <div className="settings-model-picker">
      <select
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Default model"
      >
        {models.map(m => (
          <option key={m.id} value={m.id}>{m.label}</option>
        ))}
      </select>
      {selected && <p className="settings-hint">{selected.hint}</p>}
    </div>
  );
};

export default ModelPicker;
